export default __webpack_public_path__ + "static/media/bff.f01ec2a8.png";